<template>
  <div class="trainer-configure-game traconfgm no-scroll-track">
    <CollapsePanel
      class="traconfgm_left"
      v-bind="panelDrillsProps"
      :toRight="true"
      tour="trainerpresets"
      style="
        --opener-height: 3rem;
        --inner-radius: 4px 0 0 0;
        --opener-radius: 0 0 0 4px;
        --content-padding-opened: 0.5rem 0.5rem 0 0.5rem;
      "
      :hasOpener="false"
    >
      <template #content>
        <TrainerPresets
          :namespace="namespace"
          @start="start"
        />
      </template>
    </CollapsePanel>
    <div class="traconfgm_right drag-noevents">
      <SnackbarLinkGuide
        localKey="trainer_how_to_use"
        :link="links_url_links.trainer_how_to_use.url"
        :text="$t('messages.get_most_of_trainer')"
        data-tst="message_get_most_of_trainer"
      />

      <TrainerStreetFilter
        class="traconfgm_street-settings trasett_configure"
        tour="trainerconfigure"
        :namespace="namespace"
        :hasTableName="namespaces.length > 1"
        :routerParams="{
          push: false,
          replace: true,
          saveLocally: true,
        }"
      >
        <template #main_before>
          <div class="f-column f-center ee position-relative mb-1">
            <div
              class="f-center ee weight_500 clr-grey text-normal uppercases"
              style="margin-bottom: 0.25rem"
            >
              {{ $t('common.solutions') }}
            </div>

            <GmfSelektorBtn @click="openSolutionsDialog">
              <CustomFormatOption
                v-if="solElite.want_use && (solElite.loading_what || solElite.cTree)"
                :loading="solElite.loading_what"
                :customTree="solElite.cTree"
              />
              <span
                v-else
                class="truncate text-center"
                style="
                  line-height: 1.2;
                  max-width: calc(100vw - 5rem);
                  min-width: clamp(1px, 8rem, 100vw);
                "
                v-html="gmf.mainHtml"
              ></span>
              <template #dot>
                <div
                  v-if="!solElite.want_use && gmf.listLength"
                  class="gmf-circle-list"
                >
                  {{ gmf.listLength }}
                </div>
              </template>
            </GmfSelektorBtn>
          </div>
        </template>
        <template #main_after>
          <div
            class="traconfgm_btns f-center ee"
            style="gap: 0.25rem"
          >
            <div
              id="trainer-settings-btn-open"
              class="gw_btn_text gw_btn_primary gw_btn-v1 traconfgm_btns_btn text-nowrap"
              style="--clr: var(--clr-primary)"
              :data-tst="
                shortcutsLoading || solEliteLoading
                  ? 'btn_trainer_settings_disabled'
                  : 'btn_trainer_settings'
              "
              tour="tra_advancedsettigs"
              @click="
                () => {
                  openAdvancedFilter()
                  if ($refs.PulseCircle) {
                    $refs.PulseCircle.close()
                  }
                }
              "
            >
              <i
                style="font-size: 1.1rem"
                class="traconfgm_btns_btn_icon mdi mdi-cog pa-1 my-auto"
              ></i>

              <div class="position_relative mx-auto">
                {{ mobile ? $t('btn.settings') : $t('btn.all_settings') }}
              </div>
            </div>

            <div
              id="btn_trainer_start"
              :data-tst="
                shortcutsLoading || solEliteLoading
                  ? 'btn_btn_trainer_start_disabled'
                  : 'btn_trainer_start'
              "
              class="gw_btn_primary gw_btn-v1 traconfgm_btns_btn"
              :class="{ 'gw_btn_disabled no-events': forceFoldSpot }"
              style="--clr-disabled: var(--clr-grey-2)"
              @click="start"
            >
              <i class="traconfgm_btns_btn_icon mdi mdi-play"></i>
              {{ $t('btn.start_training') }}
            </div>
          </div>
        </template>
      </TrainerStreetFilter>
    </div>

    <div
      class="role_spacer traconfgm_spacer"
      style="width: 21.5rem"
    ></div>
  </div>
</template>

<script>
import CollapsePanel from '@/components/CollapsePanel/CollapsePanel'
import CustomFormatOption from '@/components/GameFormat/CustomFormatOption'
import SnackbarLinkGuide from '@/components/Messages/SnackbarLinkGuide'
import GmfSelektorBtn from '@/components/GameFormat/GmfSelektor/GmfSelektorBtn'
import PulseCircle from '@/components/lib/PulseCircle'
import { getSetupParams } from '@/helpers/practice_trainer_calls'
import { getGameformatOptionHtml } from '@/store/gameformat/gameformat'

import TrainerStreetFilter from '@/components/Trainer/TrainerStreetFilter'
import TrainerPresets from '@/components/Trainer/TrainerPresets/TrainerPresets'

import screen_mix from '@/mixins/screen_mix'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'TrainerConfigureGame',
  components: {
    TrainerStreetFilter,
    TrainerPresets,
    CollapsePanel,
    CustomFormatOption,
    SnackbarLinkGuide,
    GmfSelektorBtn,
    PulseCircle,
  },
  mixins: [screen_mix, links_mix],
  props: {},
  emits: ['start'],
  data() {
    this.allNamespaces = ['tra/alpha', 'tra/beta', 'tra/gamma', 'tra/delta']
    return {}
  },
  methods: {
    openSolutionsDialog() {
      const tmpSecondaryNamespace = 'tmp/secondary'
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.namespace,
        to_namespace: tmpSecondaryNamespace,
        queryGroup: 'trainer',
      })
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.namespace,
        to_namespace: tmpSecondaryNamespace,
        queryGroup: 'router-to-gmf-selektor',
      })
      const dialog = `solutions-dialog_namespace-${this.namespace}_tmpNamespace-${tmpSecondaryNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    start() {
      if (!this.canStart) return
      // temporary fix cos somehow 400 - no gametype found is still rarely happening in sentry - this means disconnect in gmf_store and routerstore
      // anyhow i wanna change this to single store so all this router to gmf will cease to exist
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.namespace,
        to_namespace: this.namespace,
        queryGroup: 'router-to-gmf-selektor',
      })
      this.$emit('start')
    },
    openAdvancedFilter() {
      const tmpNamespace = 'tmp/primary'
      const dialog = `trainer-advanced-filter-dialog_namespace-${this.namespace}_tmpNamespace-${tmpNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
  },
  computed: {
    canStart() {
      if (this.forceFoldSpot) return false
      if (this.shortcutsLoading) return false
      if (this.solEliteLoading) return false
      if (this.solElite?.loading_what) return false
      return true
    },

    solElite() {
      return this.$store.getters[`${this.namespace}/sol_elite`]
    },
    gmf() {
      const nn = this.namespace
      const ssp = getSetupParams({
        namespace: nn,
        rootGetters: this.$store.getters,
        last_hand_query: null,
      })
      const customSpot = this.$store.getters[`${nn}/router_query`].fh_start_spot === 'custom_spot'
      let gmf = this.$store.getters[`${nn}/gameformat`]
      const gmfWithMostPlayers = this.$store.getters[`${nn}/gmfs_gmfWithMostPlayers`]
      if (!customSpot) {
        gmf = gmfWithMostPlayers || gmf
      }

      let listLength =
        (ssp.depth_list?.length || 0) +
        (ssp.stacks_list?.length || 0) +
        (ssp.average_stack?.length || 0)

      const gametype_list = ssp.gametype_list || []
      listLength = listLength === 1 ? 0 : listLength
      const showStackDepth = customSpot ? true : listLength === 0 && gametype_list.length <= 1
      const mainHtml = getGameformatOptionHtml({
        gameformat: gmf,
        // gametype_list,
        omitKeys: !showStackDepth
          ? [
              'depth',
              'stacks',
              'tournament_phase',
              'avg_stacks',
              '_3bet_size',
              'type_opening_size',
              'opening_type',
              'variant',
              'cash_drop',
            ]
          : ['cash69max_type'],
      })
      const res = {
        mainHtml,
        listLength,
      }
      return res
    },
    namespace() {
      return this.mobile ? 'tra/alpha' : this.$store.getters.active_namespace
    },
    namespaces() {
      return this.mobile ? ['tra/alpha'] : this.$store.getters.hands_namespaces
    },
    shortcutsLoading() {
      const res = this.$store.getters.api_get(
        'api_poker_available_shortcuts',
        this.namespace,
      ).loading
      return res
    },
    solEliteLoading() {
      return (
        this.$store.getters[`${this.namespace}/sol_elite`].loading_what ||
        this.$store.getters.api_get('api_poker_custom_user_trees').loading
      )
    },
    forceFoldSpot() {
      return (
        this.$store.getters[`${this.namespace}/fh_start_spot`] === 'custom_spot' &&
        this.$store.getters[`${this.namespace}/history_spot`]?.forced_fold
      )
    },
    panelDrillsProps() {
      return this.$store.getters.trainer_panel_drills
    },
    hotkeyPressedBottom() {
      return this.$store.getters.hotkey_pressed_bottom
    },
  },
  watch: {
    hotkeyPressedBottom(key) {
      if (!key) return
      if (key === 'enter') {
        this.start()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.gmf-circle-list {
  position: absolute;
  border-radius: 99px;
  padding: 0.125rem 0.25rem;
  background: var(--clr-primary);
  top: -0.5rem;
  flex-shrink: 0;
  right: -0.5rem;
  font-size: 0.8rem;
  z-index: 1;
}

.btn-advanced-settings {
  color: var(--clr-grey-2);
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  &:hover {
    background: var(--clr-black-1-3);
  }
}
.traconfgm {
  max-width: 100vw;
  max-height: var(--vh-3);
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: var(--clr-black-0);

  --preset-panel-width: 20rem;
  &_right {
    position: relative;
    height: var(--vh-3);
    overflow-y: auto;
    overflow-x: hidden;
    transition: 0.42s;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0 0 0;
  }
  &_street-settings {
    z-index: 1;
    margin: 2rem 0 0 0;
  }
  &_btns {
    margin: 0 0 auto 0;
    max-width: 100vw;
    display: flex;
    width: 100%;
    grid-gap: 0.25rem;
    padding: 0.75rem 0 0 0;
    align-items: center;
    &_btn {
      padding: 0 1rem;
      &_icon {
        font-size: 1.75em;
      }
    }
  }
}
@media (max-width: 1480px) {
  .traconfgm {
    &_spacer {
      display: none;
    }
  }
}
@media (max-width: 1023px) {
  .traconfgm {
    &_right {
      left: 0;
      padding: 0;
      max-height: var(--vh-5-75);
    }
    &_left {
      max-height: var(--vh-5-75);
    }
    &_street-settings {
      margin: 0rem 0 0 0;
    }
    .trasett_configure {
      --mobile-row-padding: 1rem;
    }
    &_btns {
      z-index: 10;
      background: var(--clr-black-1);
      position: fixed;
      box-shadow: 0 -1px 1px var(--clr-black-0);
      padding: 0.5rem 0.5rem 0.5rem 0.5rem;
      bottom: calc(var(--glo-footer-height) + var(--safe-area-inset-bottom));
      &_btn {
        flex: 1;
      }
    }
  }
}
</style>
